<template>
    <div style="height: 100%; width: 100%">
        <router-view :key="$route.fullPath" @edit="editActivity" @create="createActivity"></router-view>
        <community-activity-modal
            v-if="showInputModal"
            :content="activityDraft"
            :from-clipboard="fromClipboard"
            :is-edition="isEdition"
            @input="saveContent"
            @close="confirmClose"
        />
    </div>
</template>
<script>
import CommunityActivity from '@/components/CommunityActivity';
import AppButtonsFilter from '@/components/AppButtonsFilter';
import AppDropdownFilter from '@/components/AppDropdownFilter';
import CommunityActivityModal from '@/components/CommunityActivityModal';
import _ from 'underscore';
import { isEmptyObject } from '@/lib/helpers';
export default {
    components: {
        CommunityActivity,
        AppButtonsFilter,
        AppDropdownFilter,
        CommunityActivityModal,
    },
    data() {
        return {
            selectedFilter: this.$t('Constants.FILTER_OPTION_ACTIVITY_ALL'),
            dropdownActive: false,
            showInputModal: false,
            fromClipboard: false,
            activitySource: null,
            activityDraft: {
                _id: 'draft',
                accessLevel: 'administrator',
                owner: {},
                image: undefined,
                tags: [],
                title: undefined,
                shortDescription: undefined,
                area: undefined,
                layout: [],
                // folder: this.$route.params.id // TODO: check why the value is not updated
                folder: undefined,
            },
            isEdition: false,
        };
    },

    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        community() {
            return this.$store.getters.community;
        },
        isAdmin() {
            return this.community.accessLevel == 'administrator';
        },
        folder() {
            return _.findWhere(this.community.activityFolders, {
                _id: this.$route.params.id,
            });
        },
    },
    watch: {
        folder() {
            this.$store.commit('SET_ACTIVE_FOLDER', this.$route.params.id);
        },
    },
    mounted() {},
    destroyed() {
        console.log('destroying folder');
        this.$store.commit('SET_ACTIVE_FOLDER', undefined);
    },
    metaInfo() {
        let title = '';
        if (this.folder) {
            title = this.folder.name;
        }
        return {
            title: title + ' - ' + this.community.title,
            titleTemplate: '%s - Labylok',
        };
    },
    methods: {
        openModal() {
            this.showInputModal = true;
        },
        async saveContent() {
            if (
                this.hasAllRequiredFields(
                    _.omit(
                        this.activityDraft,
                        '_id',
                        'accessLevel',
                        'owner',
                        'layout'
                    )
                ) &&
                this.fieldsAreValid()
            ) {
                if (!this.isEdition) {
                    await this.$store
                        .dispatch('createActivity', {
                            object: this.activityDraft,
                            id: this.$route.params.communityId,
                        })
                        .catch((e) => {
                            console.error('error creatiorn content', e);
                            alert(e.error);
                            return;
                        });
                } else {
                    await this.$store
                        .dispatch('updateActivity', {
                            object: this.activityDraft,
                            id: this.$route.params.communityId,
                        })
                        .catch((e) => {
                            console.error('error updating', e);
                            return;
                        });
                }
                this.resetContent();
            }
        },
        hasAllRequiredFields(modelFields) {
            let trans = this;
            if (_.isObject(modelFields)) {
                //console.log("check fields")
                return _.every(modelFields, function (value, key) {
                    //console.log(key, value)
                    if (value === undefined) {
                        alert(trans.$t(`Community.error.${key}`));
                        return false;
                    }

                    //return value !== undefined;
                    return true;
                });
            }
        },
        fieldsAreValid() {
            /*if(!validators.url.test(this.courseDraft.link)){
              alert(this.$t('Community.error.url'))
              return false
            }*/
            return true;
        },
        editActivity(_id) {
            let activityToEdit = _.find(this.folder.activities, (activity) => {
                return activity._id === _id;
            });
            this.activityDraft = activityToEdit; //;
            this.activitySource = { ...activityToEdit };
            this.isEdition = true;
            this.showInputModal = true;
        },
        createActivity() {
            this.activityDraft.folder = this.$route.params.id;
            this.showInputModal = true;
        },
        resetContent() {
            this.showInputModal = false;
            this.activityDraft = {
                _id: 'draft',
                accessLevel: 'administrator',
                owner: {},
                image: undefined,
                tags: [],
                title: undefined,
                shortDescription: undefined,
                area: undefined,
                layout: [],
                folder: this.$route.params.id,
            };
            this.activitySource = null;
            this.isEdition = false;
            this.fromClipboard = false;
        },
        confirmClose() {
            const cleanDraft = _.omit(
                this.activityDraft,
                '_id',
                'folder',
                'layout',
                'accessLevel',
                'owner',
                'tags'
            );
            if (
                !isEmptyObject(cleanDraft) &&
                !_.isEqual(this.activityDraft, this.activitySource)
            ) {
                if (confirm(this.$t('Community.confirm_content_delete'))) {
                    this.resetContent();
                }
            } else {
                this.resetContent();
            }
        },
    },
};
</script>

<style scoped></style>
